module.exports = __webpack_public_path__ + "img/projects-details-3.b3718d95.jpg";